module.exports = __webpack_public_path__ + "static/media/Contact-Us-banner.b763dd0d.jpg";